import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export function RequireAuth({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-6 text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return (
      <div className="mx-auto max-w-md p-8 text-center">
        <h2 className="font-display text-2xl font-semibold">Access denied</h2>
        <p className="mt-2 text-sm text-muted-foreground">Your account doesn't have permission to view this page.</p>
      </div>
    );
  }
  return children;
}
